export function formatDateToDateTime(date: string) {
    let displayDate = new Date(date)
    return displayDate.toLocaleString()
}